module.exports = __webpack_public_path__ + "static/media/icon-terms-of-services.c31c9917.svg";